// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__11M7t","title":"InfoRow_title__2qbSX"};